import type { COMPLIANCE_APPLICATION_STATUS_TYPE } from '../../pages/Compliance/types';
import type { ApplicationStatus, ErrorListOutput } from '../../types';

type Address = {
  street: string;
  addressNumber: string;
  postalCode: string;
  municipality: string;
  region: string;
};

export interface CovieApplicationUploadSuccessResponse {
  applicationUpload: {
    id: string;
    status: ApplicationStatus | COMPLIANCE_APPLICATION_STATUS_TYPE;
    errors: never;
  };
}

export interface CovieApplicationUploadErrorResponse {
  applicationUpload: ErrorListOutput & {
    id: never;
    status: never;
  };
}

export type CovieApplicationUploadResponse =
  | CovieApplicationUploadSuccessResponse
  | CovieApplicationUploadErrorResponse;

export const COVIE_APPLICATION_UPLOAD = (
  name: string,
  firstName: string,
  lastName: string,
  email: string,
  address: Address,
  buildingUnit: string,
  documentLink: string,
  utmSource: string,
) => {
  return `mutation {
    applicationUpload(
      input: {
        documentLink: "${documentLink}",
        name: "${name}",
        firstName: "${firstName}",
        lastName: "${lastName}",
        email: "${email}",
        buildingUnit: "${buildingUnit || ''}",
        ${utmSource ? `utmSource: '${utmSource},'` : ''}
       address :{
          street: "${address.street}",
          addressNumber: "${address.addressNumber}",
          postalCode: "${address.postalCode}",
          municipality: "${address.municipality}",
          region: ${address.region}
        }
      }
    ) {
      ...on ApplicationOutput {
          id
          status
      }
      ...on ErrorListOutput {
        errors{
          type
          message
        }
      }
    }
  }
  `;
};
